import { render, staticRenderFns } from "./section-code-edit.html?vue&type=template&id=2f7c9063&scoped=true&"
import script from "./section-code-edit.js?vue&type=script&lang=js&"
export * from "./section-code-edit.js?vue&type=script&lang=js&"
import style0 from "./section-code-edit.css?vue&type=style&index=0&id=2f7c9063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7c9063",
  null
  
)

export default component.exports